import NotFoundPage from "@/pages/NotFoundPage";
import { ConfigProvider } from "antd";
import { Route, Routes } from "react-router-dom";
import { GoogleOAuthProvider } from "@react-oauth/google";
import { Toaster } from "sonner";
import { ThemeProvider } from "next-themes";

import "./instrument";
import "./styles/style.css";
import "./styles/globals.css";
import { GluceraTheme } from "./utils/GluceraTheme";
import { FoodManagementProvider } from "./context/FoodManagementContext";
import GluceraLayout from "./layouts/GluceraLayout";
import GluceraNavigationRoutes from "./utils/navigationRoutes";
import GluceraProtectedRoute from "./context/GluceraProtectedRoute";
import { GluceraAuthProvider } from "./context/GluceraAuthContext";
import routes from "./utils/routes";

const GluceraApp = () => {
  const protectedRoutes = routes.find(m => m.type === "auth")?.routes ?? [];
  const publicRoutes = routes.find(m => m.type === "public")?.routes ?? [];

  return (
    <ThemeProvider attribute="class" defaultTheme="light" enableSystem>
      <div className="min-h-screen bg-background">
        <GoogleOAuthProvider
          clientId={
            import.meta.env.VITE_GOOGLE_CLIENT_ID ??
            "453718876316-640s91mghasgsdmnc3c1kbm7jg5ojgci.apps.googleusercontent.com"
          }
        >
          <FoodManagementProvider>
            <GluceraAuthProvider>
              <ConfigProvider
                theme={{
                  hashed: false,
                  ...GluceraTheme,
                }}
                componentSize="large"
              >
                <Toaster position="top-center" richColors />
                <Routes>
                  <Route element={<GluceraLayout />}>
                    {/* Public Routes - No Authentication Required */}
                    {publicRoutes.map(({ path, element: Page }) => (
                      <Route key={path} path={path} element={<Page />} />
                    ))}

                    {/* Protected Routes - Authentication Required */}
                    <Route element={<GluceraProtectedRoute />}>
                      {protectedRoutes.map(({ path, element: Page }) => (
                        <Route key={path} path={path} element={<Page />} />
                      ))}
                    </Route>

                    <Route
                      path="*"
                      element={
                        <NotFoundPage
                          buttonLink={
                            GluceraNavigationRoutes.ONBOARDING_WELCOME
                          }
                        />
                      }
                    />
                  </Route>
                </Routes>
              </ConfigProvider>
            </GluceraAuthProvider>
          </FoodManagementProvider>
        </GoogleOAuthProvider>
      </div>
    </ThemeProvider>
  );
};

export default GluceraApp;
